import classNames from 'classnames';
import { map } from 'lodash/fp';
import { Fragment } from 'react';
import { EventTrackingProps, trackEvent } from '../../../react/services/Tracking';
import { HrisIntegration } from '../../features/OnboardingSurvey/OnboardingSurveyHris';
import styles from './style.m.less';

export interface VerticalRadioOption {
    id: string;
    name: string;
    icon: string;
    disabled?: boolean;
    trackingLabel?: string;
}

interface Props {
    value?: HrisIntegration;
    options: VerticalRadioOption[];
    onChange: (value: VerticalRadioOption) => void;
    className?: string;
    small?: boolean;
    eventTracking?: EventTrackingProps;
    urlMapping?: { [key: string]: string };
}

export const GridRadio = ({ value, options, onChange, className, small = true, eventTracking, urlMapping }: Props) => {
    return (
        <div className={classNames(className, styles.gridRadio, { small })}>
            {map(option => {
                const id = option.id;
                return (
                    <Fragment key={option.id}>
                        <input
                            id={id}
                            name={option.name}
                            disabled={option.disabled}
                            type="radio"
                            checked={value?.id === option.id}
                            onChange={() => {
                                if (eventTracking) {
                                    trackEvent({ ...eventTracking, label: option.trackingLabel });
                                }
                                return onChange(option);
                            }}
                        />
                        <label
                            htmlFor={id}
                            title={option.name}
                            className={classNames({ [styles.smallLabel]: small, [styles.regularLabel]: !small })}
                        >
                            {urlMapping && urlMapping[option.icon] && (
                                <img className={styles.image} src={urlMapping[option.icon]} alt={option.name} />
                            )}
                            {option.name}
                        </label>
                    </Fragment>
                );
            }, options)}
        </div>
    );
};
